import React, { useState } from "react";
import { Form, Row, Col, message, notification } from "antd";
import UnifiedInput from "../../components/ReportFormGenerator/UnifiedInput/UnifiedInput";
import Button from "../../components/ReportFormGenerator/Button/Button";
import liracrypt from "../../components/Liracrypt/liracrypt";
import StaticData from "./staticGil.json";
// import SetupApproval from "./SetupApproval";
import SetupApproval from "./SetupApprovalMod";

import SuspectedLotRecords from "./SuspectedLotRecords";
import RetroCheckRecords from "./RetroCheckRecords";
import ProductionApproval from "./ProductionApproval";
import QualityApproval from "./QualityApproval";
import * as Scroll from "react-scroll";
import localTemp from "./localTemp.json";
import moment from "moment";
import { NavLink } from "react-router-dom";
import FourMSupportingDocStable from "../../components/Qc/FourMSupportingDocStable";
import HModal from "../HModal";
import { useHistory } from "react-router-dom";
let Element = Scroll.Element;

let Link = Scroll.Link;

const CreateNewGil4M = ({ setPageHeader }) => {
    setPageHeader("Create 4M");
    const history = useHistory();
    const [mainTyp, setMainTyp] = React.useState("");
    const [subMainTyp, setSubMainTyp] = React.useState("");
    const [changed, setChanged] = React.useState("");
    const [selectedAction, setSelectedAction] = React.useState();
    const [typ, setTyp] = React.useState("");
    const [defaultChange, setDefaultChange] = React.useState(null);
    const [defaultAction, setDefaultAction] = React.useState(null);
    const [defaultLine, setDefaultLine] = React.useState(null);
    const [defaultDate, setDefaultDate] = React.useState(null);
    const [defaultDateTime, setDefaultDateTime] = React.useState(null);
    const [defaultShift, setDefaultShift] = React.useState(null);
    const [defaultEmployee, setdefaultEmployee] = React.useState(null);
    const [defaultModel, setDefaultModel] = React.useState(null);
    const [view4MDoc, setView4MDoc] = React.useState(false);
    const [freeze, setFreeze] = React.useState(false);

    const [abnormal, setAbnormal] = React.useState(false);

    const [loading, setLoading] = React.useState(false);
    const [templateData, setTemplateData] = React.useState(null);

    const [changeOpt, setChangeOpt] = React.useState({});
    const [actionOpt, setActionOpt] = React.useState({});
    const [inverseActionOpt, setInverseActionOpt] = React.useState({});

    const [fourMData, setFourMData] = React.useState(null);

    const [modalVisible, setModalVisible] = React.useState(false);
    const [modalData, setModalData] = React.useState(null);

    const [form] = Form.useForm();

    let urlD = new URLSearchParams(window.location.search);
    let fourMId = urlD.get("_id");

    React.useEffect(() => {
        setTemplateData(StaticData);
        // console.log(StaticData);

        if (fourMId) {
            let uiData;
            let uiDataMain;
            setFreeze(true);
            liracrypt
                .get("/bslfourm", { _id: fourMId })
                .then((res, req) => {

                    uiData = res.data.data["header"];
                    uiDataMain = res.data["data"];
                    if (uiData["man"]) {
                        setMainTyp("man");
                    }
                    if (uiData["mac"]) {
                        setMainTyp("mac");
                    }
                    if (uiData["mat"]) {
                        setMainTyp("mat");
                    }
                    if (uiData["met"]) {
                        setMainTyp("met");
                    }
                    if (uiDataMain["loc"]) {
                        setMainTyp("loc");
                    }
                    if (uiData["pln"]) {
                        setSubMainTyp("pln");
                    }
                    if (uiData["unPln"]) {
                        setSubMainTyp("unPln");
                    }
                    if (uiData["abnormal"]) {
                        setAbnormal(uiData["abnormal"]);
                    }
                    if (uiData["change"]) {
                        form.setFieldsValue({ change: uiData["change"] });
                    }
                    if (uiData["action"]) {
                        form.setFieldsValue({ action: uiData["action"] });
                    }
                    if (uiDataMain["lame"]) {
                        form.setFieldsValue({ lame: uiDataMain["lame"] });
                    }
                    if (uiDataMain["sh"]) {
                        form.setFieldsValue({ sh: uiDataMain["sh"] });
                    }
                    if (uiDataMain["mod"]) {
                        setDefaultModel(uiDataMain["mod"]);
                    }

                    if (uiDataMain["dt"]) {
                        form.setFieldsValue({ dt: moment(uiDataMain["dt"]) });
                    }

                    if (uiDataMain["dtStart"]) {
                        form.setFieldsValue({ dtStart: moment(uiDataMain["dtStart"]) });
                    }

                    if (uiDataMain["lid"]) {
                        setDefaultLine(uiDataMain["lid"]);
                    }
                    if (uiDataMain["sh"]) {
                        setDefaultShift(uiDataMain["sh"]);
                    }
                    if (uiDataMain["eid"]) {
                        setdefaultEmployee(uiDataMain["eid"]);
                    }






                    setFourMData(res.data.data);
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    document.getElementById("scrollBtn").click();
                });
        }
    }, []);

    const onFinish = (value) => {
        if (mainTyp && subMainTyp) {
            setLoading(true);
            // value["dt"] = value["dt"].format("YYYY-MM-DD").toString();
            // value["dtStart"] = value["dtStart"].format("YYYY-MM-DD").toString();
            let data = {
                man: false,
                mac: false,
                mat: false,
                met: false,
                loc: false,

                pln: false,
                unPln: false,
                abn : false,
                unPlnAbn: false,
                

                setup: selectedAction?.setup || false,
                retroChk: selectedAction?.retroChk || false,
                contain: selectedAction?.contain || false,
                custApp: selectedAction?.custApp || false

            };
            data = { ...data, ...value, [mainTyp]: true, [subMainTyp]: true, initr: typ };

            liracrypt
                .post("/gilnewfourm", data)
                .then((res, req) => {
                    notification.success({
                        message: res.data.message
                            ? res.data.message
                            : "4M Created Successfully !",
                    });
                    setTimeout(() => {
                        history.push(res.data.data.route);
                    }, 1000);
                    // setFreeze(true);
                    // setFourMData(res.data.data);

                    // setLoading(false);
                })
                .catch((err) => {
                    notification.error({
                        message: "Error Creating 4M !. Please Try Again.",
                    });
                    setLoading(false);
                });
        } else {
            if (!mainTyp) {
                message.error({ content: "Please Select 4M Typ" });
            } else {
                message.error({ content: "Please Select 4M Sub-Typ" });
            }
        }
        // setFreeze(true);
        // goToAnchor("4M");
    };

    const setChangeOptions = (typ, subTyp) => {
        if (templateData[typ][subTyp]) {
            const changeObj = {};
            Object.keys(templateData[typ][subTyp]).forEach((key, index) => {
                changeObj[key] = key;
            });

            setChangeOpt(changeObj);
        } else {
            if (!templateData[typ]) {
                message.error("Please Select Typ !");
            }
            message.error("No Conditions Applicable");
        }
    };

    const setActionOptions = (change) => {
        setChanged(change);
        // 
        setSelectedAction(null);
        if (templateData[mainTyp][subMainTyp][change]) {
            const actionObj = {};
            const inverse = {};
            Object.keys(templateData[mainTyp][subMainTyp][change]).forEach(
                (key, index) => {
                    //   console.log(actionObj);
                    actionObj[key] =
                        templateData[mainTyp][subMainTyp][change][key]["txt"];
                    inverse[templateData[mainTyp][subMainTyp][change][key]["txt"]] = key;
                }
            );

            setActionOpt(actionObj);
            setInverseActionOpt(inverse);
        } else {
            if (!templateData[mainTyp][subMainTyp][change]) {
                message.error("Please Select Change !");
            }
            message.error("Please Select Action !");
        }
    };

    const onReset = () => {
        setSubMainTyp("");
        setChangeOpt({});
        setActionOpt({});
        setAbnormal(false);
        setSelectedAction(null);
        form.resetFields();
    };

    const onPlanReset = () => {
        setChangeOpt({});
        setActionOpt({});
        form.resetFields();
    };

    const ChangeInput = () => {
        return (
            <>
                <UnifiedInput
                    form={form}
                    colSpan={24}
                    multiSelect={false}
                    disabled={freeze}
                    typ="dropDown"
                    source={"data"}
                    pname={"clauseid"}
                    name="clause"
                    label="Change"
                    errorMessage="Please Select Change"
                    required={true}
                    placeholder="Select Change"
                    searchable={true}
                    includeAll={false}
                    options={changeOpt}
                    defaultValue={defaultChange}
                    auxOnChange={setActionOptions}
                />
            </>
        );
    };

    const ActionInput = () => {
        return (
            <>
                <UnifiedInput
                    form={form}
                    colSpan={24}
                    labelSpan={24}
                    multiSelect={false}
                    disabled={freeze}
                    typ="dropDown"
                    source={"data"}
                    pname={"action"}
                    name="actionid"
                    label="Action"
                    errorMessage="Please Select Action"
                    required={true}
                    placeholder="Select Action"
                    searchable={true}
                    includeAll={false}
                    options={actionOpt}
                    auxOnChange={(change) => {
                        let obj =
                            templateData[mainTyp][subMainTyp][changed][
                            inverseActionOpt[change]
                            ];
                        setSelectedAction(obj);
                        setAbnormal(obj["abnormal"]);
                    }}
                />
            </>
        );
    };

    const RowInput = () => {
        // let uiDataMain
        // uiDataMain = res.data["data"];
        // let defSh = form.


        return (
            <>
                {/* <UnifiedInput
                    form={form}
                    colSpan={8}
                    multiSelect={false}
                    typ="dropDown"
                    url={"/mdict"}
                    disabled={freeze}
                    source={"mdict"}
                    sourceParams={{
                        typ: "Line",
                        subTyp: "idame",
                    }}
                    pname={"lame"}
                    name="lid"
                    label="Line"
                    errorMessage="Please select Line Name"
                    required={true}
                    placeholder="Select Line"
                    defaultValue={defaultLine}
                    searchable={true}
                    includeAll={false}
                />
                <UnifiedInput
                    form={form}
                    colSpan={8}
                    multiSelect={false}
                    typ="dropDown"
                    url={"/cropdown"}
                    disabled={freeze}
                    source={"cropdown"}
                    sourceParams={{ name: "PartModel" }}
                    pname={"model"}
                    name={"mod"}
                    label="Model"
                    errorMessage={"Please Select Model !"}
                    required={true}
                    placeholder="Select Model"
                    defaultValue={defaultModel}
                    searchable={true}
                    includeAll={false}
                />

                <UnifiedInput
                    form={form}
                    colSpan={8}
                    multiSelect={false}
                    typ="dropDown"
                    url={"/mdict"}
                    disabled={freeze}
                    source={"mdict"}
                    sourceParams={{
                        typ: "Employee",
                        subTyp: "idame",
                    }}
                    pname={"eame"}
                    name="eid"
                    label="Operator"
                    errorMessage="Please select Line Operator"
                    required={false}
                    placeholder="Select Operator"
                    defaultValue={defaultEmployee}
                    searchable={true}
                    includeAll={false}
                /> */}

                {/* <UnifiedInput
                    form={form}
                    colSpan={8}
                    disabled={freeze}
                    typ={"datePicker"}
                    format="YYYY-MM-DD"
                    name={"dt"}
                    label="Date"
                    errorMessage={"Please Select Date !"}
                    required={true}
                    placeholder="Select Date"
                    defaultValue={defaultDate}
                />

                <UnifiedInput
                    form={form}
                    colSpan={8}
                    multiSelect={true}
                    typ="dropDown"
                    url={"/cropdown"}
                    disabled={freeze}
                    source={"cropdown"}
                    sourceParams={{ name: "CropDown_Location" }}
                    pname={"plantLoc"}
                    name={"plant"}
                    label="Plants"
                    errorMessage={"Please Select Plant !"}
                    required={true}
                    placeholder="Select Plant"
                    defaultValue={defaultShift}
                    searchable={true}
                    includeAll={false}
                />

                <UnifiedInput
                    form={form}
                    colSpan={8}
                    disabled={freeze}
                    typ={"dateTimePicker"}
                    format="YYYY-MM-DD HH:mm:ss"
                    name={"dtStart"}
                    label="4M StartTime"
                    errorMessage={"Please Select Start DateTime !"}
                    required={true}
                    placeholder="Select Start DateTime"
                    defaultValue={defaultDateTime}
                /> */}
            </>
        );
    };

    const on4MdocumentClick = () => {
        setView4MDoc(false);
        setTimeout(() => {
            setView4MDoc(true);
        }, 500);
    }

    const onEditClick = () => {
        setModalVisible(true);
        liracrypt.get("/smodal", {
            dictName: "FourM_BSL_UpdateStartTime",
            auxFunc: { auxFuncName: "update_default_values", auxFuncParams: { auxSubFuncName: "BslUpdateStartTime", fourMid: fourMId } }
        }).then(data => {
            setModalData(data["data"]["config"]);
        }).catch(err => {
            console.error(err);
        });
    }

    const DivList = () => {
        return (
            <Element name="create" className="element bsl-output-form-list">
                <div style={{ marginTop: "10px" }}>
                    <div
                        className="edit-btn"
                        style={{ display: "flex", justifyContent: "flex-end", marginBottom: "150px", }}
                    >
                        <a
                            onClick={onEditClick}
                            // href={`/bsl/fourmsupportdocsstable?id=${fourMData["header"]["fourMNo"]}`}
                            style={{
                                backgroundColor: "#4f81bd",
                                height: "50px",
                                lineHeight: "30px",
                                padding: "0 50px",
                                border: "3px solid #395e89",
                                color: "#ffffff",
                                width: "150px",
                                textAlign: "center",
                                fontSize: "16px",
                            }}
                        >
                            EDIT
                        </a>
                    </div>

                    <div
                        style={{
                            margin: "10px",
                            marginTop: "30px",
                            padding: "20px",
                            backgroundColor: "#3b3b3b",
                            fontSize: "30px",
                            textAlign: "center",
                            color: "lightgray",
                            fontWeight: 600,
                            borderRadius: "10px",
                            boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                        }}
                    >
                        {`4M NUMBER : ${fourMData["header"]["fourMNo"]
                            ? fourMData["header"]["fourMNo"]
                            : "0"
                            }`}
                    </div>
                    {fourMData.setup.visible && (
                        <SetupApproval
                            // disabled={true}
                            disabled={fourMData["setup"]["enable"]}
                            completed={fourMData["setup"]["isComplete"]}
                            inspectorId={fourMData["setup"]["inspectorid"]}
                            inspectorName={fourMData["setup"]["inspectorName"]}
                            ok={fourMData["setup"]["ok"]}
                            rej={fourMData["setup"]["rej"]}
                            tot={fourMData["setup"]["tot"]}
                            remark={fourMData["setup"]["rmrk"]}
                            _id={fourMData["header"]["fourMNo"]}
                            setState={setFourMData}
                        />
                    )}
                    {fourMData.retroChk.visible && (
                        <RetroCheckRecords
                            // disabled={true}
                            disabled={fourMData["retroChk"]["enable"]}
                            completed={fourMData["retroChk"]["isComplete"]}
                            inspectorId={fourMData["retroChk"]["inspectorid"]}
                            inspectorName={fourMData["retroChk"]["inspectorName"]}
                            ok={fourMData["retroChk"]["ok"]}
                            rej={fourMData["retroChk"]["rej"]}
                            tot={fourMData["retroChk"]["tot"]}
                            remark={fourMData["retroChk"]["rmrk"]}
                            _id={fourMData["header"]["fourMNo"]}
                            setState={setFourMData}
                        />
                    )}
                    {fourMData.contain.visible && (
                        <SuspectedLotRecords
                            // disabled={true}
                            disabled={fourMData["contain"]["enable"]}
                            completed={fourMData["contain"]["isComplete"]}
                            inspectorId={fourMData["contain"]["inspectorid"]}
                            inspectorName={fourMData["contain"]["inspectorName"]}
                            ok={fourMData["contain"]["ok"]}
                            rej={fourMData["contain"]["rej"]}
                            tot={fourMData["contain"]["tot"]}
                            remark={fourMData["contain"]["rmrk"]}
                            _id={fourMData["header"]["fourMNo"]}
                            setState={setFourMData}
                        />
                    )}
                    {fourMData.app_Prodn.visible && (
                        <ProductionApproval
                            // disabled={true}
                            disabled={fourMData["app_Prodn"]["enable"]}
                            completed={fourMData["app_Prodn"]["isComplete"]}
                            productionId={fourMData["app_Prodn"]["app_Prodn_id"]}
                            productionName={fourMData["app_Prodn"]["app_Prodn_name"]}
                            stat={fourMData["app_Prodn"]["st_Prodn"]}
                            remark={fourMData["app_Prodn"]["rmrk_Prodn"]}
                            _id={fourMData["header"]["fourMNo"]}
                            setState={setFourMData}
                        />
                    )}

                    {fourMData.app_Qa.visible && (
                        <QualityApproval
                            // disabled={true}
                            disabled={fourMData["app_Qa"]["enable"]}
                            completed={fourMData["app_Qa"]["isComplete"]}
                            QualityId={fourMData["app_Qa"]["app_Qa_id"]}
                            QualityName={fourMData["app_Qa"]["app_Qa_name"]}
                            stat={fourMData["app_Qa"]["st_Qa"]}
                            remark={fourMData["app_Qa"]["rmrk_Qa"]}
                            _id={fourMData["header"]["fourMNo"]}
                            setState={setFourMData}
                        />
                    )}

                    <div
                        className="document-btn"
                        style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                        <a
                            onClick={on4MdocumentClick}
                            // target="_blank"
                            // href={`/bsl/fourmsupportdocsstable?id=${fourMData["header"]["fourMNo"]}`}
                            style={{
                                backgroundColor: "#4f81bd",
                                height: "70px",
                                lineHeight: "70px",
                                padding: "0 50px",
                                border: "3px solid #395e89",
                                color: "#ffffff",
                                width: "500px",
                                textAlign: "center",
                                fontSize: "26px",
                            }}
                        >
                            4M Document
                        </a>
                    </div>
                </div>
                <div style={{ minHeight: '600px' }}>
                    {
                        view4MDoc && (
                            <FourMSupportingDocStable docId={fourMData["header"]["fourMNo"]} />
                        )
                    }
                </div>

            </Element>
        );
    };

    return (
        <>
            <Link
                activeClass="create"
                to="create"
                spy={true}
                smooth={true}
                hashSpy={true}
                offset={-20}
                delay={700}
                duration={300}
                isDynamic={true}
                spyThrottle={500}
                id="scrollBtn"
            ></Link>
            <div className="new-blocks" style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}>
                <div
                    style={{
                        width: '25%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        minWidth: "150px",
                        justifyContent: "center",
                        cursor: freeze ? "not-allowed" : "pointer",
                        backgroundColor: typ == "Gabriel Initiated 4M" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (!freeze) {
                            setTyp('Gabriel Initiated 4M')
                        }
                    }}>
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-sign-out"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>Gabriel Initiated 4M</div>
                    </div>
                </div>
                <div
                    style={{
                        width: '25%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        minWidth: "150px",
                        justifyContent: "center",
                        cursor: freeze ? "not-allowed" : "pointer",
                        backgroundColor: typ == "Supplier Initiated 4M" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (!freeze) {
                            setTyp('Supplier Initiated 4M')
                        }
                    }}>
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-sign-in"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>Supplier Initiated 4M</div>
                    </div>
                </div>
                <div
                    style={{
                        width: '25%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        minWidth: "150px",
                        justifyContent: "center",
                        cursor: freeze ? "not-allowed" : "pointer",
                        backgroundColor: typ == "8D Initiated" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (!freeze) {
                            setTyp('8D Initiated')
                        }
                    }}>
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-list-ul"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>8D Initiated 4M</div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        width: '15%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        minWidth: "150px",
                        justifyContent: "center",
                        cursor: !typ ? "not-allowed" : "pointer",
                        backgroundColor: mainTyp == "man" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (typ) {
                            setMainTyp("man");
                            setSubMainTyp("");
                            onReset();
                        }
                    }}
                >
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-user"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>MAN</div>
                    </div>
                </div>
                <div
                    style={{
                        width: '15%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        cursor: !typ ? "not-allowed" : "pointer",
                        minWidth: "150px",
                        justifyContent: "center",
                        backgroundColor: mainTyp == "mac" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (typ) {
                            setMainTyp("mac");
                            setSubMainTyp("");
                            onReset();
                        }
                    }}
                >
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-gears"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>MACHINE</div>
                    </div>
                </div>
                <div
                    style={{
                        width: '15%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        cursor: !typ ? "not-allowed" : "pointer",
                        minWidth: "150px",
                        justifyContent: "center",
                        backgroundColor: mainTyp == "mat" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (typ) {
                            setMainTyp("mat");
                            setSubMainTyp("");
                            onReset();
                        }
                    }}
                >
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-th"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>MATERIAL</div>
                    </div>
                </div>
                <div
                    style={{
                        width: '15%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        cursor: !typ ? "not-allowed" : "pointer",
                        minWidth: "150px",
                        justifyContent: "center",
                        backgroundColor: mainTyp == "met" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (typ) {
                            setMainTyp("met");
                            setSubMainTyp("");
                            onReset();
                        }
                    }}
                >
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-sign-language"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>METHOD</div>
                    </div>
                </div>
            </div>
            <div className="new-blocks sub-typ" style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}>
                <div
                    style={{
                        width: '15%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        minWidth: "150px",
                        justifyContent: "center",
                        cursor: !mainTyp ? "not-allowed" : "pointer",
                        backgroundColor: subMainTyp == "pln" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (mainTyp) {
                            setSubMainTyp('pln');
                            onPlanReset();
                            setChangeOptions(mainTyp, "pln");
                        }
                    }}>
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-check-square-o"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>Planned</div>
                    </div>
                </div>
                <div
                    style={{
                        width: '15%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        minWidth: "150px",
                        justifyContent: "center",
                        cursor: !mainTyp ? "not-allowed" : "pointer",
                        backgroundColor: subMainTyp == "unPln" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (mainTyp) {
                            setSubMainTyp('unPln');
                            onPlanReset();
                            setChangeOptions(mainTyp, "unPln");

                        }
                    }}>
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-square-o"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>Unplanned</div>
                    </div>
                </div>
                <div
                    style={{
                        width: '15%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        minWidth: "150px",
                        justifyContent: "center",
                        cursor: !mainTyp ? "not-allowed" : "pointer",
                        backgroundColor: subMainTyp == "abn" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (mainTyp) {
                            setSubMainTyp('abn');
                            onPlanReset();
                            setChangeOptions(mainTyp, "abn");
                        }
                    }}>
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-square"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>Abnormal</div>
                    </div>
                </div>
                <div
                    style={{
                        width: '15%',
                        display: "flex",
                        padding: "30px",
                        margin: "30px",
                        minWidth: "150px",
                        justifyContent: "center",
                        cursor: !mainTyp ? "not-allowed" : "pointer",
                        backgroundColor: subMainTyp == "unPlnAbn" ? "#8e44ad" : "#3b3b3b",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: 600,
                        borderRadius: "10px",
                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                    }}
                    onClick={() => {
                        if (mainTyp) {
                            setSubMainTyp('unPlnAbn');
                            onPlanReset();
                            setChangeOptions(mainTyp, "unPlnAbn");
                        }
                    }}>
                    <div style={{ display: "block", textAlign: "center" }}>
                        <i
                            className="fa fa-minus-square"
                            style={{ margin: "5px", fontSize: "30px" }}
                        ></i>
                        <div style={{ padding: 0, margin: 0 }}>Abnormal Unplanned</div>
                    </div>
                </div>
            </div>

            <div style={{ padding: "30px" }}>
                <div className="AuditSection CreateAudit">
                    <div className="ThemeForm">
                        <Form
                            name="ReportForm"
                            form={form}
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            layout="horizontal"
                            colon={false}
                            onFinish={onFinish}
                            size="large"
                        >
                            <Row gutter={24}>
                                <ChangeInput />
                            </Row>
                            <Row gutter={24}>
                                <ActionInput />
                            </Row>
                            <Row gutter={24} style={{ marginTop: "15px" }}>
                                <RowInput />
                            </Row>


                            <div className="new-blocks" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div
                                    style={{
                                        width: '15%',
                                        display: "flex",
                                        padding: "30px",
                                        margin: "30px",
                                        minWidth: "150px",
                                        justifyContent: "center",
                                        cursor: "not-allowed",
                                        backgroundColor: selectedAction?.setup ? "#FFA500" : "#3b3b3b",
                                        color: "#fff",
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        borderRadius: "10px",
                                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                                    }}>
                                    <div style={{ display: "block", textAlign: "center" }}>
                                        <i
                                            className="fa fa-cogs"
                                            style={{ margin: "5px", fontSize: "30px" }}
                                        ></i>
                                        <div style={{ padding: 0, margin: 0 }}>Setup</div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: '15%',
                                        display: "flex",
                                        padding: "30px",
                                        margin: "30px",
                                        minWidth: "150px",
                                        justifyContent: "center",
                                        cursor: "not-allowed",
                                        backgroundColor: selectedAction?.retroChk ? "#FFA500" : "#3b3b3b",
                                        color: "#fff",
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        borderRadius: "10px",
                                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                                    }}>
                                    <div style={{ display: "block", textAlign: "center" }}>
                                        <i
                                            className="fa fa-retweet"
                                            style={{ margin: "5px", fontSize: "30px" }}
                                        ></i>
                                        <div style={{ padding: 0, margin: 0 }}>Retro</div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: '15%',
                                        display: "flex",
                                        padding: "30px",
                                        margin: "30px",
                                        minWidth: "150px",
                                        justifyContent: "center",
                                        cursor: "not-allowed",
                                        backgroundColor: selectedAction?.contain ? "#FFA500" : "#3b3b3b",
                                        color: "#fff",
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        borderRadius: "10px",
                                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                                    }}>
                                    <div style={{ display: "block", textAlign: "center" }}>
                                        <i
                                            className="fa fa-braille"
                                            style={{ margin: "5px", fontSize: "30px" }}
                                        ></i>
                                        <div style={{ padding: 0, margin: 0 }}>Containment</div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: '15%',
                                        display: "flex",
                                        padding: "30px",
                                        margin: "30px",
                                        minWidth: "150px",
                                        justifyContent: "center",
                                        cursor: "not-allowed",
                                        backgroundColor: selectedAction?.custApp ? "#FFA500" : "#3b3b3b",
                                        color: "#fff",
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        borderRadius: "10px",
                                        boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                                    }}>
                                    <div style={{ display: "block", textAlign: "center" }}>
                                        <i
                                            className="fa fa-thumbs-o-up"
                                            style={{ margin: "5px", fontSize: "30px" }}
                                        ></i>
                                        <div style={{ padding: 0, margin: 0 }}>Cust Approval</div>
                                    </div>
                                </div>
                            </div>

                            {!freeze ? (
                                <Row gutter={24} justify="center" style={{ marginTop: "15px" }}>
                                    <Col span={24}>
                                        <Button
                                            form={form}
                                            loading={loading}
                                            cancelButtonText={"Reset"}
                                            submitButtonText={"Create 4M"}
                                            resetButton={true}
                                            width="100%"
                                        />
                                    </Col>
                                </Row>
                            ) : null}
                        </Form>
                    </div>
                </div>
            </div>

            {fourMData ? (
                <>
                    <HModal
                        isModalVisible={modalVisible}
                        setIsModalVisible={setModalVisible}
                        modalMethod={"edit"}
                        action={{ edit: modalData }}
                        modalData={null}
                        extraData={{ _id: fourMData["header"]["fourMNo"], typ: "setup" }}
                        mergeData={true}
                        setState={setFourMData}
                    />
                    <DivList />
                </>
            ) : (
                <>{/* <div style={{ minHeight: "100vh" }}></div> */}</>
            )}
        </>
    );
}

export default CreateNewGil4M;
